import {
  Button,
  ButtonType,
  Modal,
  ModalBodyWithSections,
  ModalFooter,
  ModalHeader,
  colors,
  icons,
  getTestAttributes,
  noop,
} from '@chillibean/component-library';
import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export function ExportSuccessModal(props) {
  const { onClose = noop, visible = false } = props;

  return (
    <Modal onClose={onClose} visible={visible}>
      <ModalHeader closeable onClose={onClose} title="Export Started" />
      <CustomModalBodyWithSections>
        <ContentContainer>
          <IconSection>
            <Icon color={colors.blue.dark} height={48} icon={icons.baselineDataThreshold} width={48} />
          </IconSection>
          <HeaderSection>Your export is being generated...</HeaderSection>
          <ContentSection {...getTestAttributes('flash-message')}>
            We&apos;re working on exporting all your data. We&apos;ll send you an email with the file when the export is
            complete. The email will come from ChilliPharm {`<notifications@chillipharm.com>`}
          </ContentSection>
          <SmallTextSection>
            It should just take a few minutes, but may take longer depending on how much data you have
          </SmallTextSection>
        </ContentContainer>
      </CustomModalBodyWithSections>
      <ModalFooter>
        <Button onClick={onClose} text="CLOSE" type={ButtonType.PRIMARY} />
      </ModalFooter>
    </Modal>
  );
}

const CustomModalBodyWithSections = styled(ModalBodyWithSections)`
  background-color: ${colors.white.primary};
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 16px;
  text-align: center;
`;

const IconSection = styled.div``;

const HeaderSection = styled.div`
  font-weight: 700;
  font-size: 24px;
  color: ${colors.black.medium};
`;

const ContentSection = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: ${colors.black.medium};
`;

const SmallTextSection = styled.div`
  font-weight: 400;
  font-size: 13px;
  color: ${colors.black.medium};
`;

ExportSuccessModal.propTypes = {
  onClose: PropTypes.func,
  visible: PropTypes.bool,
};

export default ExportSuccessModal;
